import AuthoredPage from '../components/AuthoredPage';
import PageBack from '../components/PageBack';
import SiteFooter from '../../../shared-web/SiteFooter';
import aboutHtml from './authored/about.html?raw';
import how_ember_worksHtml from './authored/how-ember-works.html?raw';
import real_human_experiencesHtml from './authored/real-human-experiences.html?raw';
import share_your_experienceHtml from './authored/share-your-experience.html?raw';
import privacy_and_sharingHtml from './authored/privacy-and-sharing.html?raw';
import community_guidelinesHtml from './authored/community-guidelines.html?raw';
import compareHtml from './authored/compare.html?raw';
import compare_ember_vs_chatgptHtml from './authored/compare-ember-vs-chatgpt.html?raw';
import compare_ember_vs_journaling_appsHtml from './authored/compare-ember-vs-journaling-apps.html?raw';
import ways_to_use_emberHtml from './authored/ways-to-use-ember.html?raw';

/**
 * The authored marketing pages — the brand-narrative and comparison pages
 * whose body is an authored HTML delivery (scripts/import-authored-marketing-pages.py;
 * the 2026-09-15 delivery and the 2026-09-29 comparison articles). The
 * platform supplies the chrome — the Back row, the footer, the head via
 * site-content.json. Ten page files carried this same component with a
 * different `?raw` import each (2026-09-30 盘点); this is the one, and the
 * table is what App.tsx routes by.
 */
export const AUTHORED_PAGES: Record<string, string> = {
  // the footer's "About Ember" entry: why Oriscen built the product and what it believes about AI's role in it
  '/about': aboutHtml,
  // the footer's Understand entry
  '/how-ember-works': how_ember_worksHtml,
  // the footer's Understand entry
  '/real-human-experiences': real_human_experiencesHtml,
  // left the footer with the 2026-08-30 redesign, stays routable for campaigns and search
  '/share-your-experience': share_your_experienceHtml,
  // the footer's Understand entry
  '/privacy-and-sharing': privacy_and_sharingHtml,
  // the community guidelines
  '/community-guidelines': community_guidelinesHtml,
  // the comparison articles' index (2026-09-30): their breadcrumbs and footers named it from the first day
  '/compare': compareHtml,
  // comparison article (2026-09-29)
  '/compare/ember-vs-chatgpt': compare_ember_vs_chatgptHtml,
  // comparison article (2026-09-29)
  '/compare/ember-vs-journaling-apps': compare_ember_vs_journaling_appsHtml,
  // the situation pages' hub; /use-cases and /experiences 301 here at the edge
  '/ways-to-use-ember': ways_to_use_emberHtml,
};

export function AuthoredMarketingPage({ html }: { html: string }) {
  return (
    <div
      className="flex min-h-screen flex-col text-ink"
      style={{ background: 'var(--eh-canvas, #fcf7ec)' }}
    >
      <div className="eh-page-top authored-top-wrap">
        <PageBack />
      </div>
      <AuthoredPage html={html} />
      <SiteFooter theme="light" />
    </div>
  );
}
